<template>
  <v-dialog persistent v-model="showModal" max-width="500" dark>
    <div id="modal-infoimg">
    <div v-if="loader" class="loader">
      <v-icon>mdi-loading mdi-spin</v-icon>
    </div>

    <!-- Modal Card -->
    <v-card>
      <v-card-title class="headline">
        <v-icon color="warning">warning</v-icon>
        <p>
          {{$t('titles.startAnalyze')}} 
        </p>
      </v-card-title>
      <v-card-text>
        <ul>
          <li class="mb-2">
            {{$t('texts.nbrImages', images.length)}}: <strong>{{images.length}}</strong> <br> 
          </li>
          <li class="mb-2">
            {{$t('texts.projectType')}}: <strong>{{category}}</strong>
          </li>
          <li class="mb-2">
            {{$t('texts.tags')}}: <strong>{{tags}}</strong>
          </li>
          <li class="mb-2">
            {{$t('texts.destinationFolder')}}: <strong>{{projects}}</strong>
          </li>
        </ul>
      </v-card-text>
      <v-card-actions class="center">
        <v-btn color="primary" flat @click="showModal = false">{{$t('buttons.cancel')}}</v-btn>
        <v-btn color="primary" flat @click="confirmAnalyze">{{$t('buttons.analyzeAll')}}</v-btn>
      </v-card-actions>
    </v-card>
    </div>
  </v-dialog>
</template>
<script>
export default {
  props: {
    modalImg: Boolean,
    tags: String,
    projects: String,
    category: String
  },
  data() {
    return {
      showModal: false,
      loader: false
    };
  },
  mounted() {
    this.showModal = this.modalImg;
  },
  watch: {
    modalImg(value) {
      this.showModal = value;
    },
    showModal(value) {
      if (value === false) {
        this.$emit('close-modal');
        this.loader = false;
      }
    }
  },
  computed: {
    images() {
      return this.$store.getters["image/getPreviews"];
    }
  },
  methods: {
    confirmAnalyze() {
      this.$emit('analyze');
      this.loader = true;
    }
  }
};
</script>
<style lang="sass">
#modal-infoimg 
  position: relative
  .v-btn:focus 
    outline: none

  .headline 
    display: flex !important
    i
      flex: 1
    p
      flex: 5
      margin: 0

  .loader 
    position: absolute
    width: 100%
    height: 100%
    z-index: 1000
    background-color: rgba(0, 0, 0, .5)

  .loader i 
    position: absolute
    z-index: 1050
    left: 50%
    top: 50%
    transform: translate(-50%, -50%)
    font-size: 3rem

</style>